import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import AutocompleteField from '../../formFields/autocompleteField';
import InputField from '../../formFields/InputField';
import { useSelector } from 'react-redux';

export const FormaDePago = (props:any) => {


  const { payment_frequency_select }:any = useSelector( (state:any) => state.paymentfrequency );
  const { payment_method_list_select }:any = useSelector( (state:any) => state.paymentmethod );
  const { associated_bank_select }:any = useSelector( (state:any) => state.associatedbank );
  const { type_account_bank_list_select }:any = useSelector( (state:any) => state.typeaccountbank );
  

    const { formField: {
      payment_frequency,
      payment_method,
      associated_bank,
      type_account_bank,
      account_number,
    }
  } = props;



  const tdocument = [
    { label: 'Cedula', id: 'hjgjgjhgh'},
    { label: 'Tarjeta de identidad', id: 'sdfdf'}
  ];

 


  return (
    <div>
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <AutocompleteField
                   options={payment_frequency_select}
                   name={payment_frequency.name}
                   label={payment_frequency.label}
                />
            </Grid>
            <Grid item xs={4}>
                <AutocompleteField
                   options={payment_method_list_select}
                   name={payment_method.name}
                   label={payment_method.label}
                />
            </Grid>
            <Grid item xs={4}>
                <AutocompleteField
                   options={associated_bank_select}
                   name={associated_bank.name}
                   label={associated_bank.label}
                />
            </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={4}>
                <AutocompleteField
                   options={type_account_bank_list_select}
                   name={type_account_bank.name}
                   label={type_account_bank.label}
                />
            </Grid>
            <Grid item xs={4}>
                 <InputField
                    name={account_number.name}
                    label={account_number.label}
                    variant="outlined" 
                    fullWidth
                  />
            </Grid>
        </Grid>
       
        
    </div> 
  )
}
